module.exports = __webpack_public_path__ + "static/media/arrow-right-round-active.d6d6575f.png";